export type SimpleQuoteInteractionType = "ACCEPT" | "CANCEL" | "DECLINE";

interface SimpleQuoteInteractionConfig {
  actionUrl: string;
  contentText: string;
  title: string;
  actionButtonText: string;
  actionButtonColor: "primary" | "warning" | "error";
}

export function getSimpleQuoteInteractionConfig(
  quoteId: number,
  type: SimpleQuoteInteractionType,
): SimpleQuoteInteractionConfig {
  switch (type) {
    case "ACCEPT":
      return {
        actionUrl: `/quotes/${quoteId}/accept`,
        contentText: "Please confirm you wish to accept the selected quote.",
        title: "Book Shipment",
        actionButtonText: "accept quote",
        actionButtonColor: "primary",
      };
    case "CANCEL":
      return {
        actionUrl: `/quotes/${quoteId}/cancel`,
        contentText: "Please confirm you wish to cancel the selected quote.",
        title: "Cancel Quote",
        actionButtonText: "cancel quote",
        actionButtonColor: "error",
      };
    case "DECLINE":
      return {
        actionUrl: `/quotes/${quoteId}/decline`,
        contentText: "Please confirm you wish to decline the selected quote.",
        title: "Decline Quote",
        actionButtonText: "decline quote",
        actionButtonColor: "warning",
      };
    default:
      throw Error("Unexpected action type");
  }
}
